import { render, staticRenderFns } from "./InvitacionesList.vue?vue&type=template&id=5af2a9ae"
import script from "./InvitacionesList.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitacionesList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports